import React from "react";

const Services = ({ classicHeader, darkTheme }) => {
  // services details
  const services = [
    {
      name: "Software Development",
      desc: "Experienced in developing software solutions tailored to meet specific business needs. Skilled in various programming languages and frameworks.",
      icon: "fas fa-palette",
    },
    {
      name: "Web & Mobile Design",
      desc: "Passionate about creating visually stunning and user-friendly web and mobile interfaces. Proficient in UI/UX design principles and tools.",
      icon: "fas fa-desktop",
    },
    {
      name: "UI/UX Design",
      desc: "Focused on crafting intuitive and visually appealing user experiences. Proficient in wireframing, prototyping, and usability testing.",
      icon: "fas fa-pencil-ruler",
    },
    {
      name: "Ecommerce Development",
      desc: "Experienced in developing robust and scalable ecommerce solutions. Proficient in payment gateway integration, inventory management, and user authentication.",
      icon: "fas fa-chart-area",
    },
    {
      name: "Web & Mobile Development",
      desc: "Skilled in building responsive and dynamic web and mobile applications. Proficient in front-end and back-end technologies, ensuring seamless user experiences.",
      icon: "fas fa-bullhorn",
    },
    {
      name: "Devops & Solution Architecture",
      desc: "Experienced in implementing DevOps practices and designing scalable architecture solutions. Proficient in cloud platforms, CI/CD pipelines, and infrastructure management.",
      icon: "fas fa-cogs",
    },
    {
      name: "Database Management & Administration",
      desc: "Expertise in managing and optimizing databases. Skilled in data modeling, performance tuning, and ensuring data security and integrity.",
      icon: "fas fa-database",
    },
    {
      name: "ERP & CRM Software",
      desc: "Experienced in developing and implementing ERP (Enterprise Resource Planning) and CRM (Customer Relationship Management) software solutions. Skilled in database management, data modeling, performance tuning, and ensuring data security and integrity.",
      icon: "fas fa-tasks",
    }
    
    
  ];

  return (
    <section
      id="services"
      className={"section " + (darkTheme ? "bg-dark-2" : "bg-light")}
    >
      <div className={"container " + (classicHeader ? "" : "px-lg-5")}>
        {/* Heading */}
        <div className="position-relative d-flex text-center mb-5">
          <h2
            className={
              "text-24  text-uppercase fw-600 w-100 mb-0 " +
              (darkTheme ? "text-white-50  opacity-1" : "text-light  opacity-4")
            }
          >
            Services
          </h2>
          <p
            className={
              "text-9  fw-600 position-absolute w-100 align-self-center lh-base mb-0 " +
              (darkTheme ? "text-white" : "text-dark")
            }
          >
            What I Do?
            <span className="heading-separator-line border-bottom border-3 border-primary d-block mx-auto" />
          </p>
        </div>
        {/* Heading end*/}
        {/* content start */}
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <div className="row">
              {services.length > 0 &&
                services.map((service, index) => (
                  <div className="col-md-6" key={index}>
                    <div className="featured-box style-3 mb-5">
                      <div
                        className={
                          "featured-box-icon text-primary  shadow-sm rounded " +
                          (darkTheme ? "bg-dark-1" : "bg-white")
                        }
                      >
                        <i className={service.icon} />
                      </div>
                      <h3 className={darkTheme ? "text-white" : ""}>
                        {service.name}
                      </h3>
                      <p
                        className={"mb-0 " + (darkTheme ? "text-white-50" : "")}
                      >
                        {service.desc}
                      </p>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
        {/* content end */}
      </div>
    </section>
  );
};

export default Services;
